module.exports = __webpack_public_path__ + "0ace1e7c1d63e5da6326023a83083fd1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/AuthorBlock/images/ic_continueonmobile.svg
// module id = 1159
// module chunks = 2